import React, { createContext, useState, useEffect } from "react";

//  Create the UserContext
export const UserContext = createContext();

//  Create the UserProvider Component
export const UserProvider = ({ children }) => {

  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null; // Parse stored user data
  });

  const [UserId, setId] = useState(() => {
    const savedId = localStorage.getItem("UserId");
    return savedId ? JSON.parse(savedId) : 0;
  });

  const [UserToken, setToken] = useState(() => {
    const savedToken = localStorage.getItem("UserToken");
    return savedToken ? JSON.parse(savedToken) : null;
  });
  const [userRole, setRole] = useState(() => {
    const savedRole = localStorage.getItem("userRole");
    return savedRole ? JSON.parse(savedRole) : null;
  });
  const [UserEmail, setEmail] = useState(() => {
    const savedEmail = localStorage.getItem("UserEmail");
    return savedEmail ? JSON.parse(savedEmail) : null;
  });
  const [UserMobile, setMobile] = useState(() => {
    const savedMobile = localStorage.getItem("UserMobile");
    return savedMobile ? JSON.parse(savedMobile) : null;
  });
  const [UserDateOfBirth, setDateOfBirth] = useState(() => {
    const savedDateOfBirth = localStorage.getItem("UserDateOfBirth");
    return savedDateOfBirth ? JSON.parse(savedDateOfBirth) : null;
  });
  const [UserGender, setGender] = useState(() => {
    const savedGender = localStorage.getItem("UserGender");
    return savedGender ? JSON.parse(savedGender) : null;
  });
  
  // Update localStorage whenever the user changes
  useEffect(() => {
    if (user,UserId, UserToken, userRole, UserEmail, UserMobile) {
      localStorage.setItem("user", JSON.stringify(user)); // Save user to localStorage
      localStorage.setItem("UserId", JSON.stringify(UserId));
      localStorage.setItem("UserToken", JSON.stringify(UserToken));
      localStorage.setItem("userRole", JSON.stringify(userRole));
      localStorage.setItem("UserEmail", JSON.stringify(UserEmail));
      localStorage.setItem("UserMobile", JSON.stringify(UserMobile));
      localStorage.setItem("UserDateOfBirth", JSON.stringify(UserDateOfBirth));
      localStorage.setItem("UserGender", JSON.stringify(UserGender));
    } else {
      localStorage.removeItem("user"); // Clear localStorage if user is null
      localStorage.removeItem("UserId");
      localStorage.removeItem("UserToken");
      localStorage.removeItem("userRole");
      localStorage.removeItem("UserEmail");
      localStorage.removeItem("UserMobile");
      localStorage.removeItem("UserDateOfBirth");
      localStorage.removeItem("UserGender");
    }
  }, [user, UserId, UserToken, userRole, UserEmail, UserMobile, UserDateOfBirth, UserGender]);

  const logout = () => {
    // Clear session data
    localStorage.removeItem("UserToken");
    localStorage.removeItem("user");
    localStorage.removeItem("UserId");
    localStorage.removeItem("userRole");
    localStorage.removeItem("UserEmail");
    localStorage.removeItem("UserMobile");
    localStorage.removeItem("UserDateOfBirth");
    localStorage.removeItem("UserGender");
    setUser(null);
    setId(0);
    setToken(null);
    setRole(null);
    setEmail(null);
    setGender(null);
    setMobile(null);
    setDateOfBirth(null);
    setGender(null);
  };

  return (
    <UserContext.Provider value={{ user, setUser, logout, UserId, setId, UserToken, setToken, userRole, setRole, setEmail, UserEmail, setMobile, UserMobile, setDateOfBirth, UserDateOfBirth, setGender, UserGender }}>
      {children}
    </UserContext.Provider>
  );
};
